import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import moment from 'moment'
import { IModalBase } from '@interfaces/commonInterfaces'

export interface IState {
  roleGroupList?: any
  roleGroupOptionList?: any
  roleGroupDetail?: any
  reloadRoleGroupList?: string | null
  modalRoleGroup?: IModalBase
}

const initialState: IState = {
  roleGroupList: [],
  roleGroupOptionList: [],
  roleGroupDetail: {},
  reloadRoleGroupList: null,
  modalRoleGroup: {
    visible: false,
    record: {}
  }

}

export const roleGroupDucks = createSlice({
  name: 'roleGroup',
  initialState,
  reducers: {

    getListRoleGroup: (state: RootState, action: PayloadAction<any>) => {
      state.roleGroupList = { loading: true, queryStr: action.payload }
    },
    getListRoleGroupSuccess: (state, action: PayloadAction<any>) => {
      state.roleGroupList = { loading: false, ...action.payload }
    },
    getListRoleGroupFail: (state, action: PayloadAction<any>) => {
      state.roleGroupList = { loading: false, ...action.payload }
    },

    getListOptionRoleGroup: (state: RootState, action: PayloadAction<any>) => {
      state.roleGroupOptionList = { loading: true, queryStr: action.payload }
    },
    getListOptionRoleGroupSuccess: (state, action: PayloadAction<any>) => {
      state.roleGroupOptionList = { loading: false, ...action.payload }
    },
    getListOptionRoleGroupFail: (state, action: PayloadAction<any>) => {
      state.roleGroupOptionList = { loading: false, ...action.payload }
    },

    getDetailRoleGroup: (state: RootState, action: PayloadAction<any>) => {
      state.roleGroupDetail = { loading: true, id: action.payload }
    },
    getDetailRoleGroupSuccess: (state, action: PayloadAction<any>) => {
      state.roleGroupDetail = { loading: false, ...action.payload }
    },
    getDetailRoleGroupFail: (state, action: PayloadAction<any>) => {
      state.roleGroupDetail = { loading: false, ...action.payload }
    },
    
    setReloadRoleGroupList: (state: RootState) => {
      state.reloadRoleGroupList = String(moment())
    },
    setModalRoleGroup: (state, action: PayloadAction<IModalBase>) => {
      state.modalRoleGroup = action.payload
    },

  },
})

// Action creators are generated for each case reducer function
export const {
  getListRoleGroup,
  getListRoleGroupSuccess,
  getListRoleGroupFail,

  getListOptionRoleGroup,
  getListOptionRoleGroupSuccess,
  getListOptionRoleGroupFail,

  getDetailRoleGroup,
  getDetailRoleGroupSuccess,
  getDetailRoleGroupFail,

  setReloadRoleGroupList,
  setModalRoleGroup
} = roleGroupDucks.actions

export default roleGroupDucks.reducer
